// extracted by mini-css-extract-plugin
module.exports = {"scroll":"Scroll_scroll__3Pokw","noDisplay":"Scroll_noDisplay__xYOLp"};